/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { TXT_NOT_AVAILABLE } from 'translations';

const MenuItemNotAvailable: FC = () => {
  const { t } = useTranslation();

  return <Typography>{t(TXT_NOT_AVAILABLE)}</Typography>;
};

export default MenuItemNotAvailable;
